const Cadastro = () => {
  return (
    <iframe title="iframe testes" className="absolute w-full h-full" src="https://form.jotform.com/240675950736061"/>
  );
};

export default Cadastro;
